module.exports = __webpack_public_path__ + "img/demo-panel.0116de89.png";